import axios from 'axios';
// import router from '../routerManuaConfig'
import router from '../router/index'
import store from "../store";
import Vue from 'vue';

import applicationUserManager from "../Auth/applicationusermanager";

// 根据环境设置基础URL
let base = '';
if (process.env.NODE_ENV === 'development') {
    // 开发环境直接使用线上接口
    base = '';
} else {
    // 生产环境使用完整URL
    base = 'https://api.ruiei.com';
}

// 请求延时
axios.defaults.timeout = 20000

var storeTemp = store;
axios.interceptors.request.use(
    config => {
        var curTime = new Date()
        var expiretime = new Date(Date.parse(storeTemp.state.tokenExpire))

        if (storeTemp.state.token && (curTime < expiretime && storeTemp.state.tokenExpire)) {
            // 判断是否存在token，如果存在的话，则每个http header都加上token
            config.headers.Authorization = "Bearer " + storeTemp.state.token;
        }

        saveRefreshtime();

        return config;
    },
    err => {
        return Promise.reject(err);
    }
);

// http response 拦截器
axios.interceptors.response.use(

    response => {
        return response;
    },
    error => {

        let errInfo = { success: false, message: "错误" }
        // 超时请求处理
        var originalRequest = error.config;
        if (error.code == 'ECONNABORTED' && error.message.indexOf('timeout') != -1 && !originalRequest._retry) {
            errInfo.message = "请求超时！";
            originalRequest._retry = true
        } else if (error.response) {
            if (error.response.status == 401) {
                var curTime = new Date()
                var refreshtime = new Date(Date.parse(window.localStorage.refreshtime))
                // 在用户操作的活跃期内
                if (window.localStorage.refreshtime && (curTime <= refreshtime)) {
                    return refreshToken({ token: window.localStorage.Token }).then((res) => {
                        if (res.success) {
                            Vue.prototype.$message({
                                message: 'refreshToken success! loading data...',
                                type: 'success'
                            });

                            store.commit("saveToken", res.response.token);

                            var curTime = new Date();
                            var expiredate = new Date(curTime.setSeconds(curTime.getSeconds() + res.response.expires_in));
                            store.commit("saveTokenExpire", expiredate);

                            error.config.__isRetryRequest = true;
                            error.config.headers.Authorization = 'Bearer ' + res.response.token;
                            return axios(error.config);
                        } else {
                            // 刷新token失败 清除token信息并跳转到登录页面
                            ToLogin()
                        }
                    });
                } else {
                    // 返回 401，并且不知用户操作活跃期内 清除token信息并跳转到登录页面
                    ToLogin()
                }

            }
            // 403 无权限
            else if (error.response.status == 403) {
                errInfo.message = "失败！该操作无权限";
            }
            // 429 ip限流
            else if (error.response.status == 429) {
                errInfo.message = "刷新次数过多，请稍事休息重试！";
            } else if (error.response.status == 404) {
                // 404 不存在
                errInfo.message = "失败！访问接口不存在";
            } else if (error.response.status == 500) {
                // 500 服务器异常
                errInfo.message = "失败！服务器异常";
            } else if (error.response.status == 405) {
                // 405 请求http方法错误
                errInfo.message = "失败！请求http方法错误";
            } else if (error.response.status == 415) {
                // 415 参数没有指定Body还是Query
                errInfo.message = "失败！参数没有指定Body还是Query";
            } else {
                //其他错误参数
                errInfo.message = '失败！请求错误' + error.response.status;
            }
        } else {
            errInfo.message = "失败！服务器断开";
        }
        Vue.prototype.$message({
            message: errInfo.message,
            type: 'error'
        });
        return errInfo; // 返回接口返回的错误信息
    }
);


export const BaseApiUrl = base;


// 登录 - 使用 POST 请求，避免密码暴露在 URL 中
export const requestLogin = params => {
    return axios.post(`${base}/api/login/PostLogin`, params).then(res =>
        res.data
    );
};
export const requestLoginMock = params => { return axios.post(`${base}/login`, params).then(res => res.data); };

export const refreshToken = params => {
    return axios.get(`${base}/api/login/RefreshToken`, { params: params }).then(res => res.data);
};

export const saveRefreshtime = params => {

    let nowtime = new Date();
    let lastRefreshtime = window.localStorage.refreshtime ? new Date(window.localStorage.refreshtime) : new Date(-1);
    let expiretime = new Date(Date.parse(window.localStorage.TokenExpire))

    let refreshCount = 1;//滑动系数
    if (lastRefreshtime >= nowtime) {
        lastRefreshtime = nowtime > expiretime ? nowtime : expiretime;
        lastRefreshtime.setMinutes(lastRefreshtime.getMinutes() + refreshCount);
        window.localStorage.refreshtime = lastRefreshtime;
    } else {
        window.localStorage.refreshtime = new Date(-1);
    }
};
const ToLogin = params => {

    store.commit("saveToken", "");
    store.commit("saveTokenExpire", "");
    store.commit("saveTagsData", "");
    window.localStorage.removeItem('user');
    window.localStorage.removeItem('NavigationBar');



    if (global.IS_IDS4) {
        applicationUserManager.login();
    } else {
        router.replace({
            path: "/login",
            query: { redirect: router.currentRoute.fullPath }
        });
        //window.location.reload()
    }
};

export const getUserByToken = params => {
    return axios.get(`${base}/api/user/getInfoByToken`, { params: params }).then(res => res.data);
};


export function testapi2() {
    console.log('api is ok.')
}

export const testapi = pa => {
    console.log('api is ok.')
}

// 用户管理
export const getUserListPage = params => {
    return axios.get(`${base}/api/user/get`, { params: params });
};
export const removeUser = params => {
    return axios.delete(`${base}/api/user/delete`, { params: params });
};
export const editUser = params => {
    return axios.put(`${base}/api/user/put`, params);
};
export const addUser = params => {
    return axios.post(`${base}/api/user/post`, params);
};
export const batchRemoveUser = params => {
    return axios.delete(`${base}/api/Claims/BatchDelete`, { params: params });//没做
};

// 角色管理
export const getRoleListPage = params => {
    return axios.get(`${base}/api/role/get`, { params: params });
};
export const removeRole = params => {
    return axios.delete(`${base}/api/role/delete`, { params: params });
};
export const editRole = params => {
    return axios.put(`${base}/api/role/put`, params);
};
export const addRole = params => {
    return axios.post(`${base}/api/role/post`, params);
};

// 接口模块管理
export const getModuleListPage = params => {
    return axios.get(`${base}/api/module/get`, { params: params });
};
export const removeModule = params => {
    return axios.delete(`${base}/api/module/delete`, { params: params });
};
export const editModule = params => {
    return axios.put(`${base}/api/module/put`, params);
};
export const addModule = params => {
    return axios.post(`${base}/api/module/post`, params);
};


// 菜单模块管理
export const getPermissionListPage = params => {
    return axios.get(`${base}/api/permission/get`, { params: params });
};
export const getPermissionTreeTable = params => {
    return axios.get(`${base}/api/permission/GetTreeTable`, { params: params });
};
export const removePermission = params => {
    return axios.delete(`${base}/api/permission/delete`, { params: params });
};
export const editPermission = params => {
    return axios.put(`${base}/api/permission/put`, params);
};
export const addPermission = params => {
    return axios.post(`${base}/api/permission/post`, params);
};
export const getPermissionTree = params => {
    return axios.get(`${base}/api/permission/getpermissiontree`, { params: params });
};
export const getPermissionIds = params => {
    return axios.get(`${base}/api/permission/GetPermissionIdByRoleId`, { params: params });
};

export const addRolePermission = params => {
    return axios.post(`${base}/api/permission/Assign`, params);
};
export const getNavigationBar = params => {
    return axios.get(`${base}/api/permission/GetNavigationBar`, { params: params }).then(res => res.data);
};

// Bug模块管理
export const getBugListPage = params => {
    return axios.get(`${base}/api/TopicDetail/get`, { params: params });
};
export const removeBug = params => {
    return axios.delete(`${base}/api/TopicDetail/delete`, { params: params });
};
export const editBug = params => {
    return axios.put(`${base}/api/TopicDetail/update`, params);
};
export const addBug = params => {
    return axios.post(`${base}/api/TopicDetail/post`, params);
};


// 博客模块管理
export const getBlogListPage = params => {
    return axios.get(`${base}/api/Blog`, { params: params });
};
export const getBlogDeatil = params => {
    return axios.get(`${base}/api/Blog/DetailNuxtNoPer`, { params: params });
};
export const editBlog = params => {
    return axios.put(`${base}/api/Blog/update`, params);
};
export const removeBlog = params => {
    return axios.delete(`${base}/api/Blog/delete`, { params: params });
};

// 日志
export const getLogs = params => {
    return axios.get(`${base}/api/Monitor/get`, { params: params });
};
export const getRequestApiinfoByWeek = params => {
    return axios.get(`${base}/api/Monitor/GetRequestApiinfoByWeek`, { params: params });
};
export const getAccessApiByDate = params => {
    return axios.get(`${base}/api/Monitor/GetAccessApiByDate`, { params: params });
};
export const getAccessApiByHour = params => {
    return axios.get(`${base}/api/Monitor/GetAccessApiByHour`, { params: params });
};
export const getServerInfo = params => {
    return axios.get(`${base}/api/Monitor/Server`, { params: params });
};
export const getAccessLogs = params => {
    return axios.get(`${base}/api/Monitor/GetAccessLogs`, { params: params });
};
export const getIds4UsersGrow = params => {
    return axios.get(`${base}/api/Monitor/GetIds4Users`, { params: params });
};
export const getActiveUsers = params => {
    return axios.get(`${base}/api/Monitor/GetActiveUsers`, { params: params });
};


// Task管理
export const getTaskListPage = params => {
    return axios.get(`${base}/api/TasksQz/get`, { params: params });
};
export const removeTask = params => {
    return axios.delete(`${base}/api/TasksQz/delete`, { params: params });
};
export const editTask = params => {
    return axios.put(`${base}/api/TasksQz/put`, params);
};
export const addTask = params => {
    return axios.post(`${base}/api/TasksQz/post`, params);
};

export const startJob = params => {
    return axios.get(`${base}/api/TasksQz/StartJob`, { params: params });
};
export const stopJob = params => {
    return axios.get(`${base}/api/TasksQz/StopJob`, { params: params });
};
export const reCovery = params => {
    return axios.get(`${base}/api/TasksQz/ReCovery`, { params: params });
};
export const pauseJob = params => {
    return axios.get(`${base}/api/TasksQz/PauseJob`, { params: params });
};
export const resumeJob = params => {
    return axios.get(`${base}/api/TasksQz/ResumeJob`, { params: params });
};
export const getTaskNameSpace = params => {
    return axios.get(`${base}/api/TasksQz/GetTaskNameSpace`, { params: params });
};

// ids4
export const getAchieveUsers_IS4 = params => {
    return axios.get(`${base}/is4api/GetAchieveUsers`, { params: params });
};


//微信公众号
export const getWeChatAccount = params => {
    return axios.get(`${base}/api/WeChatConfig/get`, { params: params });
};
export const removeWeChatAccount = params => {
    return axios.delete(`${base}/api/WeChatConfig/delete`, { params: params });
};
export const batchDeleteChatAccount = params => {
    return axios.delete(`${base}/api/WeChatConfig/BatchDelete`, { params: params });
};
export const addWeChatAccount = params => {
    return axios.post(`${base}/api/WeChatConfig/post`, params);
};
export const updateWeChatAccount = params => {
    return axios.put(`${base}/api/WeChatConfig/put`, params);
};
export const getWeChatTemplate = params => {
    return axios.get(`${base}/api/WeChat/GetTemplate`, { params: params });//获取模板
};
export const refreshWeChatToken = params => {
    return axios.get(`${base}/api/WeChat/RefreshToken`, { params: params });//更新Token
};
export const getWeChatMenu = params => {
    return axios.get(`${base}/api/WeChat/GetMenu`, { params: params });//获取微信菜单
};
export const updateWeChatMenu = params => {
    return axios.put(`${base}/api/WeChat/updateMenu`, params);//更新微信菜单
};
export const getWeChatCompany = params => {
    return axios.get(`${base}/api/WeChatCompany/get`, { params: params });
};
export const removeWeChatCompany = params => {
    return axios.delete(`${base}/api/WeChatCompany/delete`, { params: params });
};
export const batchDeleteWeChatCompany = params => {
    return axios.delete(`${base}/api/WeChatCompany/BatchDelete`, { params: params });
};
export const addWeWeChatCompany = params => {
    return axios.post(`${base}/api/WeChatCompany/post`, params);
};
export const updateWeChatCompany = params => {
    return axios.put(`${base}/api/WeChatCompany/put`, params);
};
export const getWeChatPushLog = params => {
    return axios.get(`${base}/api/WeChatPushLog/get`, { params: params });
};
export const getWeChatSubUser = params => {
    return axios.get(`${base}/api/WeChat/GetSubUsers`, { params: params });
};
export const getWeChatBindUser = params => {
    return axios.get(`${base}/api/WeChatSub/get`, { params: params });
};
export const pushTestMsg = params => {
    return axios.post(`${base}/api/WeChat/PushTxtMsg`, params);
};
export const pushCardMsg = params => {
    return axios.post(`${base}/api/WeChat/PushCardMsg`, params);
};


//获取查询树形table
export const getColumnTreeTable = params => {
    return axios.get(`${base}/api/Column/GetTreeTable`, { params: params });
};
//获取栏目详情
export const getColumnDetails = params => {
    return axios.get(`${base}/api/Column/GetInfoById`, { params: params });
};
//添加栏目
export const addColumn = params => {
    return axios.post(`${base}/api/Column/Post`, params);
};
//修改栏目
export const updateColumn = params => {
    return axios.put(`${base}/api/Column/Put`, params);
};
//删除栏目
export const deleteColumn = params => {
    return axios.delete(`${base}/api/Column/Delete`, { params: params });
};
//修改状态
export const updateColumnStatus = params => {
    return axios.put(`${base}/api/Column/UpdateStatus?ids=${params.ids}&newStatus=${params.newStatus}`, "");
};
//修改排序
export const updateColumnSort = params => {
    return axios.put(`${base}/api/Column/UpdateOrderSort?id=${params.id}&orderSort=${params.orderSort}`, "");
};

//获取模型管理列表
export const getModelList = params => {
    return axios.get(`${base}/api/SysTemplate/Get`, { params: params });
};
//获取模型管理详情
export const getModelDetail = params => {
    return axios.get(`${base}/api/SysTemplate/GetInfoById`, { params: params });
};
//添加模型
export const addModel = params => {
    return axios.post(`${base}/api/SysTemplate/Post`, params);
};
//编辑模型
export const editModel = params => {
    return axios.put(`${base}/api/SysTemplate/Put`, params);
};
//删除模型
export const deleteModel = params => {
    return axios.delete(`${base}/api/SysTemplate/Delete`, { params: params });
};
//获取字段列表
export const getFieldList = params => {
    return axios.get(`${base}/api/SysTemplateFields/Get`, { params: params });
};
//获取自定义字段详情
export const getFieldDetail = params => {
    return axios.get(`${base}/api/SysTemplateFields/GetInfoById`, { params: params });
};
//获取控件类型
export const getControlTypeList = params => {
    return axios.get(`${base}/api/SysTemplateFields/GetControlTypeList`, { params: params });
};
//获取验证类型
export const getRegExpTypeList = params => {
    return axios.get(`${base}/api/SysTemplateFields/GetRegExpTypeList`, { params: params });
};
//添加自定义字段
export const addCustomizeField = params => {
    return axios.post(`${base}/api/SysTemplateFields/Post`, params);
};
//编辑自定义字段
export const editCustomizeField = params => {
    return axios.put(`${base}/api/SysTemplateFields/Put`, params);
};
//删除自定义字段
export const deleteCustomizeField = params => {
    return axios.delete(`${base}/api/SysTemplateFields/Delete`, { params: params });
};
//修改排序
export const updayeOrderSort = params => {
    return axios.put(`${base}/api/SysTemplateFields/UpdayeOrderSort`, params);
};
//获取模型预览
export const getPreviewInfo = params => {
    return axios.get(`${base}/api/SysTemplate/GetPreviewInfoById`, { params: params });
};


//获取查询树形table
export const getSiteColumnTreeTable = params => {
    return axios.get(`${base}/api/SiteColumn/GetTreeTable`, { params: params });
};
//获取栏目详情
export const getSiteColumnDetails = params => {
    return axios.get(`${base}/api/SiteColumn/GetInfoById`, { params: params });
};
//添加栏目
export const addSiteColumn = params => {
    return axios.post(`${base}/api/SiteColumn/Post`, params);
};
//获取所有栏目树
export const getSiteColumnSelect = params => {
    return axios.get(`${base}/api/SiteColumn/GetColumnSelect`, { params: params });
};
//修改栏目
export const updateSiteColumn = params => {
    return axios.put(`${base}/api/SiteColumn/Put`, params);
};
//删除栏目
export const deleteSiteColumn = params => {
    return axios.delete(`${base}/api/SiteColumn/Delete`, { params: params });
};
//修改状态 
export const updateSiteColumnStatus = params => {
    return axios.put(`${base}/api/SiteColumn/UpdateStatus`, params);
};
//修改显示
export const updateSiteColumnShow = params => {
    return axios.put(`${base}/api/SiteColumn/UpdateShow`, params);
};
//修改排序  
export const updateSiteColumnSort = params => {
    return axios.put(`${base}/api/SiteColumn/UpdateOrderSort`, params);
};

//获取站点列表
export const getSiteList = params => {
    return axios.get(`${base}/api/Site/Get`, { params: params });
};
//获取站点详情
export const getSiteDetails = params => {
    return axios.get(`${base}/api/Site/GetById`, { params: params });
};
//添加站点
export const addSite = params => {
    return axios.post(`${base}/api/Site/Post`, params);
};
//修改栏目
export const updateSite = params => {
    return axios.put(`${base}/api/Site/Put`, params);
};
//删除栏目
export const deleteSite = params => {
    return axios.delete(`${base}/api/Site/Delete`, { params: params });
};
//修改状态
export const updateSiteStatus = params => {
    return axios.put(`${base}/api/Site/UpdateStatus`, params);
};
//修改排序
export const updateSiteSort = params => {
    return axios.put(`${base}/api/Site/UpdateOrderSort?id=${params.id}&orderSort=${params.orderSort}`, "");
};


//获取图片分类列表
export const getImageTypeList = params => {
    return axios.get(`${base}/api/ImageType/Get`, { params: params });
};
//获取图片分类详情
export const getImageTypeDetails = params => {
    return axios.get(`${base}/api/ImageType/GetById`, { params: params });
};
//添加图片分类
export const addImageType = params => {
    return axios.post(`${base}/api/ImageType/Post`, params);
};
//修改图片分类
export const updateImageType = params => {
    return axios.put(`${base}/api/ImageType/Put`, params);
};
//删除图片分类
export const deleteImageType = params => {
    return axios.delete(`${base}/api/ImageType/Delete`, { params: params });
};
//修改图片分类排序
export const updateImageTypeSort = params => {
    return axios.put(`${base}/api/ImageType/UpdateOrderSort`, params);
};
//获取图片分类  下拉框
export const imageSelect = params => {
    return axios.get(`${base}/api/ImageType/GetImageTypeSelect`, { params: params });
};
//获取图片列表
export const getImagesList = params => {
    return axios.get(`${base}/api/Images/Get`, { params: params });
};
//获取图片详情
export const getImageDetails = params => {
    return axios.get(`${base}/api/Images/GetById`, { params: params });
};
//获取图片详情
export const getImageDetailsBatch = params => {
    return axios.get(`${base}/api/Images/GetByIds`, { params: params });
};
//删除图片分类
export const deleteImage = params => {
    return axios.delete(`${base}/api/Images/Delete`, { params: params });
};
//修改图片
export const updateImage = params => {
    return axios.put(`${base}/api/Images/Put`, params);
};
//修改图片标题和描述
export const updateImagesTitle = params => {
    return axios.post(`${base}/api/Images/UpdateFileTitle`, params);
};


//获取文件分类列表
export const getFileTypeList = params => {
    return axios.get(`${base}/api/FilesType/Get`, { params: params });
};
//获取文件分类详情
export const getFileTypeDetails = params => {
    return axios.get(`${base}/api/FilesType/GetById`, { params: params });
};
//添加文件分类
export const addFileType = params => {
    return axios.post(`${base}/api/FilesType/Post`, params);
};
//修改文件分类
export const updateFileType = params => {
    return axios.put(`${base}/api/FilesType/Put`, params);
};
//删除文件分类
export const deleteFileType = params => {
    return axios.delete(`${base}/api/FilesType/Delete`, { params: params });
};
//修改文件分类排序
export const updateFileTypeSort = params => {
    return axios.put(`${base}/api/FilesType/UpdateOrderSort`, params);
};

//获取文件列表
export const getFilesList = params => {
    return axios.get(`${base}/api/Files/Get`, { params: params });
};
//获取文件详情
export const getFilesDetails = params => {
    return axios.get(`${base}/api/Files/GetById`, { params: params });
};
//获取文件详情
export const getFilesDetailsBatch = params => {
    return axios.get(`${base}/api/Files/GetByIds`, { params: params });
};
//删除文件分类
export const deleteFiles = params => {
    return axios.delete(`${base}/api/Files/Delete`, { params: params });
};
//修改文件
export const updateFiles = params => {
    return axios.put(`${base}/api/Files/Put`, params);
};
export const filesSelect = params => {
    return axios.get(`${base}/api/FilesType/GetImageTypeSelect`, { params: params });
};
// //修改文件标题和描述
export const updateFilesTitle = params => {
    return axios.post(`${base}/api/Files/UpdateFileTitle`, params);
};

//获取系统配置
export const getSysConfig = params => {
    return axios.get(`${base}/api/SysConfig/Get`, { params: params });
};
//获取水印字体
export const getWatermarkFont = params => {
    return axios.get(`${base}/api/SysConfig/GetWatermarkFontList`, { params: params });
};
//图片水印位置
export const getWatermarkPosition = params => {
    return axios.get(`${base}/api/SysConfig/GetWatermarkPositionList`, { params: params });
};
//图片水印类型
export const getWatermarkType = params => {
    return axios.get(`${base}/api/SysConfig/GetWatermarkTypeList`, { params: params });
};
//
export const getWatermarkTypeList = params => {
    return axios.get(`${base}/api/SysConfig/GetConfigWatermarkTypeList`, { params: params });
};
//添加配置
export const addSysConfig = params => {
    return axios.post(`${base}/api/SysConfig/Post`, params);
};
//修改配置
export const updateSysConfig = params => {
    return axios.put(`${base}/api/SysConfig/Put`, params);
};

//上传图片
export const uploadImage = params => {
    return axios.post(`${base}/api/Images/UploadFile`, params);
};

//内容管理列表
export const getContentManage = params => {
    return axios.get(`${base}/api/ContentManage/GetFixedContentList`, { params: params });
};

//内容管理详情
export const getContentDetails = params => {
    return axios.get(`${base}/api/ContentManage/GetById`, { params: params });
};
//内容管理新增、获取动态表单
export const getContentAdd = params => {
    return axios.get(`${base}/api/ContentManage/GetContentField`, { params: params });
};
//添加内容
export const addContent = params => {
    return axios.post(`${base}/api/ContentManage/Post`, params);
};
//编辑内容
export const updateContent = params => {
    return axios.put(`${base}/api/ContentManage/Put`, params);
};
//删除内容
export const deleteContent = params => {
    return axios.delete(`${base}/api/ContentManage/Delete`, { params: params });
};
//修改内容排序
export const updateContentSort = params => {
    return axios.put(`${base}/api/ContentManage/UpdateOrderSort`, params);
};
//获取组图管理列表
export const getGroupList = params => {
    return axios.get(`${base}/api/Photos/Get`, { params: params });
};
//获取组图管理列表
export const getGroupDetails = params => {
    return axios.get(`${base}/api/Photos/GetByIds`, { params: params });
};
//添加组图、
export const addGroupImage = params => {
    return axios.post(`${base}/api/Photos/Post`, params);
};
//编辑组图、
export const editGroupImage = params => {
    return axios.put(`${base}/api/Photos/Put`, params);
};
//删除组图
export const deleteGroupImage = params => {
    return axios.delete(`${base}/api/Photos/Delete`, { params: params });
};
//修改组图排序
export const groupOrderSort = params => {
    return axios.put(`${base}/api/Photos/UpdateOrderSort`, params);
};
//预约
export const getAppointmentList = params => {
    return axios.get(`${base}/api/TSAppointmentAdmin/GetPageList`, { params: params });
};
// export const uploadFile = params => {
//     return axios.put(`${base}/api/Photos/UpdateOrderSort`, params);
// };